namespace advisorop.components.advisor {
    "use strict"
    export class RepGroupListController {
        $router;

        public model: Array<domains.IRepFeeGroup>;
        public dg: DevExpress.ui.dxDataGridOptions;
        n: number;
        repFeeGroup: domains.IRepFeeGroup;
        isInEditState: number;
        advisorFirm: any;
        companyGroup: domains.ICompanyGroup;

        allocation: domains.RepFeeGroupAllocation = new domains.RepFeeGroupAllocation();
        dgAllocationAdvisorSettings: DevExpress.ui.dxDataGridOptions;
        selectedAdvisor: domains.IAdvisor = null;
        availableFeePercentage = 1;
        adv: domains.IAdvisor = {};
        user: domains.identity.IUser = {};

        addNewRepGroup: boolean = false;
        addNewGroup: any;

        stateCreateRepFee: boolean = false;
        returnedData: boolean;

        static $inject = ["repGroupApi", "generalService"];
        constructor(private repGroupApi: services.RepGroupApi, private gs: services.GeneralService) {


            this.repFeeGroup = {
                allocations: []
            };



            this.dg = {
                export: {
                    enabled: true,
                    fileName: "RepGroups"
                },
                bindingOptions: {
                    dataSource: "vm.model"
                },
                scrolling: {
                    mode: "standard",
                    useNative: true
                },
                //height: "350px",
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                noDataText: "No Rep Groups",
                //stateStoring: {
                //    enabled: false,
                //    type: "localStorage",
                //    storageKey: "dgAlertLogs"
                //},
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    width: 240,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "dateCreated", dataType: "date", format: "shortDateShortTime", caption: "Created", width: 150 },
                    { dataField: "name", caption: "Name" },
                    { dataField: "noFeesPermissionOnly", caption: "No Fees", visible: true, width: 60 },
                    { dataField: "repNumber", caption: "Rep Number", visible: true },
                    { dataField: "systemLoginCreated.fullName", caption: "Created by", width: 160 },
                    { dataField: "id", caption: "Actions", cellTemplate: "colActions", width: 160 }
                ]
            };
        }

        initNewRepFeeGroup() {
            this.availableFeePercentage = 1;
            this.allocation.percentage = 1;
            this.isInEditState = 1;
            this.stateCreateRepFee = true;
            this.addNewRepGroup = true;
            this.addNewGroup({ evt: this.addNewRepGroup })
        }


        decrementAvailablePercentage(percentage: number) {

            this.availableFeePercentage = this.availableFeePercentage - percentage;

            if (this.availableFeePercentage < 0)
                this.availableFeePercentage = 0;
            else if (this.availableFeePercentage > 1)
                this.availableFeePercentage = 1;
        };


        repGroupId: number = 0;

        //Get Rep Fee Group By Id

        getRepFeeGroupById(repFeeGroupId: number): void {


            this.isInEditState = 1;
            this.availableFeePercentage = 1;
        
            this.repGroupId = repFeeGroupId;


            this.repGroupApi.getById(repFeeGroupId)
                .then(data => {
                    this.repFeeGroup = data.data;

                   // repGroupIdLocal = this.repFeeGroup.id;
                    this.repGroupId = this.repFeeGroup.id;
                    var sumOfPercents: number = 0;
                    for (var i = 0; i <= this.repFeeGroup.allocations.length - 1; i++) {
                        sumOfPercents = sumOfPercents + this.repFeeGroup.allocations[i].percentage;
                    }
                    this.decrementAvailablePercentage(sumOfPercents);
                    this.allocation.percentage = this.availableFeePercentage;
                }, err => this.gs.showErrorWithMessage('Can not find this group', err))

        };


        //Delete Rep Fee Group
        deleteRepFeeGroup(repFeeGroup: domains.IRepFeeGroup): void {

            if (!confirm("Would you realy like to delete " + repFeeGroup.name + " rep group?"))
                return;

            var x = this.model;

            this.repGroupApi.deleteRepGroup(repFeeGroup.id)
                .then(data => {
                    toastr.success("Group deleted.");
                    var ind = x.indexOf(repFeeGroup);
                    if (ind >= 0) {
                        x.splice(ind, 1);
                    }
                }, err => this.gs.showErrorWithMessage("Could not delete this group.", err));
        };


        loadRepFeeGroups(): void {
            this.repGroupApi.filterByOption(domains.RepGroupFeeOptions.BOTH)
                .then(data => {
                    this.model = data.data;
                }, err => this.gs.showError(err));
        }
        
        onGroupCreated(event: domains.IRepFeeGroup): void {
            this.repFeeGroup = event;
            this.isInEditState = 0;
            this.$onInit();
        }

        $onInit(): void {
            this.loadRepFeeGroups();
        }
    }
    
    class RepGroupList implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {      
                "router": "<",
                addNewGroup: "&"
              
            };
            this.controller =  RepGroupListController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/rep-group-list.html';
        }
    }
    angular.module(Constants.APP).component("repGroupList", new RepGroupList());
}